<template>
        <!-- ============================================================== -->
        <!-- Page wrapper  -->
        <!-- ============================================================== -->
    <div
    id="wrapper"
    class=""
    style="background-image: url('assets/images/background/login-register.jpg');background-size: cover;background-repeat: no-repeat;background-position: center center;height: 100%;width: 100%;padding: 0;position: fixed;">
          <div class="login-box card" style="position: absolute;margin: 0px 0 0 0px; top: 20%;left: 38%;">
                <div class="card-body" style="width:325px;">
                    <form class="form-horizontal form-material" id="loginform" action="">
                        <div class="form-group">
                            <div class="col-xs-12 text-center">
                                <div class="user-thumb text-center"> 
                                    <img v-if="Image == ''" src="assets/images/profile.jpg" alt="user" class="img-circle"
                                        style="height:120px;width:120px;"> 
                                       <img v-else :src=Image alt="user" class="img-circle" 
                                       style="height:130px;width:130px;">
                                    <h3>{{profileInfo.FirstName}} {{profileInfo.LastName}}</h3>
                                </div>
                            </div>
                        </div>
                        <div class="form-group ">
                            <div class="col-xs-12">
                                <input class="form-control" 
                                v-model="lockScreens.Password" type="password" required="" placeholder="password">
                            </div>
                        </div>
                        <div class="form-group text-center">
                            <div class="col-xs-12">
                                <a @click="lockScreen()"><button 
                                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" 
                                type="submit">Login</button></a>
                            </div>
                        </div>
                    </form>
                     </div>
      <div style="text-align: left; font-size: x-small;margin-left: auto;">
          <button class="btnOut" @click="logoutClick"> Logout </button>
        </div>
    </div>
                </div>
         
</template>

<script>
import axios from "axios";
//import config from '../../router/config'

export default {
  data() {
    return {
     //loader
     loader:"",
         //Timer
      TimerObject: {},
     lockScreens: {},
     profileInfo: {},
     Image: '',
     Id: ''
    };
  }, // end data

methods: {
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, 1.8e+6);
    },
    ResetLogoutTime(){
      clearTimeout(this.TimerObject);
          this.TimerObject = setTimeout(() => {
           this.AutoLogout();
          }, 1.8e+6);
    },

 lockScreen() {
        if (!this.lockScreens.Password) {
                this.ShowWarning("Password is required");
                event.preventDefault();
                return;
    }

    event.preventDefault();
    const str = localStorage.OSversion;
    const arr = str.split("<VEINS2021/>");
    var UserId = arr[0];
    this.lockScreens.UserId = UserId;
      const url =this.SERVER + "/VNSPRAAPI/Practices/Lockscreen"
      this.axiosPostLock(url,1);
    },
        async axiosPostLock(Url){
          var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      await axios({
        method:'post',
        data: this.lockScreens,
        url:Url,
        headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
      .then((res) =>{
        loader.hide();
        const result = res.data;
        if(result.status){
           localStorage.icore = "point"
          //this.msetIcore("point");
          window.location.href = '/'
        }
       else{
           localStorage.icore = "lockscreen"
          //this.msetIcore("lockscreen");
           this.ShowWarning("Wrong Password entered");
       }
      }).catch(function(error)
      {
      alert(console.log(error));
      }).finally(()=>{   
        this.ResetLogoutTime();
        loader.hide();
      });
   },

GetProfileInfo(){
      const str = localStorage.OSversion;
      const arr = str.split("<VEINS2021/>");
      var UserId = arr[0];
      this.Id = UserId;
      const url = this.SERVER + "/VNSPRAAPI/Practices/GetProfile?UserId=" + UserId;
      this.axiosGetProfileData1(url);
    },
        async axiosGetProfileData1(Url){
          var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      console.log('GetData');
      await axios({
        method:'get',
        url:Url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
      .then((res) =>{
        loader.hide();
        const result = res.data
        if(result.status){
         this.profileInfo = result.data[0]; 
         this.name = result.data[0].FirstName + " " + result.data[0].LastName;
        }
      }).catch(function(error)
      {
      alert(console.log(error));
      }).finally(()=>{
          this.ResetLogoutTime();
          loader.hide();
      });

    this.GetUserImage(this.Id);
},

//For Image
 GetUserImage(UserId){
      const url = this.SERVER + "/VNSPRAAPI/Practices/GetUserProfilePics?UserProfileId=" + UserId;
      this.axiosGetUserData11(url);
    },
        async axiosGetUserData11(Url){
          var loader = this.$loading.show({
              // Optional parameters
                color: '#03a9f3'
              });
      console.log('GetData');
      await axios({
        method:'get',
        url:Url,
         headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
      })
      .then((res) =>{
        loader.hide();
        this.Image = res.data;
        this.$forceUpdate();
      }).catch(function(error)
      {
      alert(console.log(error));
      }).finally(()=>{ loader.hide();
this.ResetLogoutTime();
      });
    },
    logoutClick() {
            this.loader = this.$loading.show({
            // Optional parameters
              color: '#03a9f3'
            });

        localStorage.icore = "";
        location.href = this.USERSSERVER;
    }

},
mounted() {
   this.GetProfileInfo();
   this.StartLogoutTime();
  }, //end methods
  unmounted() {
        clearTimeout(this.TimerObject);
      },
};

</script>

<style scoped>
.btnOut {
  border: none;
  background-color: inherit;
  padding: 9px 10px;
  font-size: 9px;
  cursor: pointer;
  display: inline-block;
}
</style>